export default "__VITE_ASSET__B0$z7PIi__"